<template>
  <v-dialog
    v-model="$store.state.ui.appErrorCard.isAppErrorCardShown"
    width="450"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-sheet class="pt-4 pb-6" color="error" tile>
        <div class="d-flex justify-end pr-2">
          <v-icon size="18" color="grey lighten-3" @click="closeDialog">mdi-close</v-icon>
        </div>
        <div class="py-2 d-flex justify-center">
          <v-icon size="80" color="#fff">mdi-close-circle-outline</v-icon>
        </div>
      </v-sheet>
      <v-card-text class="py-8">
        <p style="font-size: 2.5rem" class="mb-5 text-center black--text darken-5">Ooops!</p>
        <p
          style="font-size: 0.9rem"
          class="text-center"
          v-if="!$store.state.ui.appErrorCard.errorText.includes('not owned by')"
        >
          {{ $store.state.ui.appErrorCard.errorText }}
        </p>
        <p
          style="font-size: 0.9rem"
          class="text-center"
          v-else-if="$store.state.ui.appErrorCard.errorText.includes('Refresh Token has expired')"
        >
          Your session has exprired. Please log in once more
        </p>
        <p v-else class="text-center">
          It appears you don't have permission to access this page.
          <!-- You can go -->
          <!-- <button
                        @click="go(-1)"
                        style="background: none;border: none;outline: none;color: #1976d2;"
                    >
                        back
                    </button> -->
          Go to the main page
          <v-btn to="/" icon color="#1976d2"><v-icon>launch</v-icon></v-btn>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppErrorCard',

  methods: {
    closeDialog() {
      this.$store.commit('setAppErrorCardState', {
        state: false,
        errorText: null,
      })
    },
  },

  watch: {
    $route(newValue, oldValue) {
      if (newValue.fullPath !== oldValue.fullPath) {
        this.closeDialog()
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
